import {
  REFERENCE_DEFAULT_OFFER_PAGE_ORIGIN,
  referenceActivityRangeForFilter,
  referenceOfferTypeForLocalPaymentKind,
  referenceTabForBucket,
} from './referenceOfferLogic';

export const OFFER_PAGE_TRACKING_PAGE_NAME = 'offer_page';

export const OFFER_PAGE_TRACKING_EVENTS = Object.freeze({
  OFFER_PAGE_VIEW: 'offer_pageview',
  OFFER_TAB_CLICKED: 'offer_tab_clicked',
  OFFER_REFRESH_BUTTON_CLICKED: 'offer_refresh_button_clicked',
  OFFER_QUICK_FILTERS_CLICKED: 'offer_quick_filters_clicked',
  OFFER_FILTERS_TYPE_CLEAR_CLICKED: 'offer_filters_type_clear_clicked',
  OFFER_DETAILS_PAGE_VIEW: 'offer_details_pageview',
  OFFER_DETAILS_CHAT_BUTTON_CLICKED: 'offer_details_chat_button_clicked',
  OFFER_FILTERS_RECENT_ACTIVITIES_APPLY_CLICKED:
    'offer_filters_recent_activities_apply_clicked',
  OFFER_FILTERS_RECENT_ACTIVITIES_CLEAR_CLICKED:
    'offer_filters_recent_activities_clear_clicked',
  OFFER_ERROR_REFRESH_BUTTON_CLICKED: 'offer_error_refresh_button_clicked',
  OFFER_STATUS_LIST_ERROR_REFRESH_BUTTON_CLICKED:
    'offer_status_list_error_refresh_button_clicked',
});

const ACTIVITY_MONTHS_LABEL = Object.freeze({
  1: 'one_month',
  2: 'two_months',
  3: 'three_months',
  4: 'four_months',
  6: 'six_months',
  12: 'twelve_months',
});

const compactPayload = payload =>
  Object.fromEntries(
    Object.entries(payload).filter(([, value]) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== '' && value !== null && value !== undefined;
    })
  );

export const offerPageTrackingEnvelope = (properties = {}) =>
  compactPayload({
    pageName: OFFER_PAGE_TRACKING_PAGE_NAME,
    ...properties,
  });

export const offerPageViewPayload = ({
  origin = REFERENCE_DEFAULT_OFFER_PAGE_ORIGIN,
  size,
  totalCount,
  visibleCount,
} = {}) =>
  offerPageTrackingEnvelope({
    origin: origin || REFERENCE_DEFAULT_OFFER_PAGE_ORIGIN,
    size,
    total_count: totalCount,
    visible_count: visibleCount,
  });

export const offerTabPayload = bucket =>
  offerPageTrackingEnvelope({
    offer_tabs: referenceTabForBucket(bucket),
  });

export const offerTypeFilterPayload = paymentKind =>
  offerPageTrackingEnvelope({
    offer_type: referenceOfferTypeForLocalPaymentKind(paymentKind),
  });

export const recentActivityLabel = activityFilter => {
  const months = String(activityFilter?.months || '');
  return ACTIVITY_MONTHS_LABEL[months] || 'custom_range';
};

const formatTrackingDate = value => {
  if (!value) return '';
  const [year, month, day] = String(value).split('-');
  if (!year || !month || !day) return '';
  return `${day}/${month}/${year}`;
};

export const offerRecentActivityPayload = (
  activityFilter,
  now = new Date()
) => {
  const range = referenceActivityRangeForFilter(activityFilter, now);
  return offerPageTrackingEnvelope({
    recent_activities: recentActivityLabel(activityFilter),
    start_date: formatTrackingDate(range.startDate),
    end_date: formatTrackingDate(range.endDate),
  });
};

export const offerDetailsChatPayload = ({
  channel = 'chat',
  offerId,
  conversationId,
} = {}) =>
  offerPageTrackingEnvelope({
    channel,
    offer_id: offerId,
    conversation_id: conversationId,
  });
